import { useMediaQuery, useTheme } from '@mui/material';

// Canonical way to branch on viewport size — use these instead of importing useMediaQuery
// directly in feature code, so every screen-size check agrees on the same breakpoints
// (defined once in theme.ts, not re-typed as magic px values per call site).
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

export function useIsTablet(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between('sm', 'md'));
}

export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
